import axiosInstance from './axiosInstance';
const API_URL = process.env.REACT_APP_API_URL;

export const getPurchasePriceItems = async () => (await axiosInstance.get(`${API_URL}/purchase-price-items`)).data;
export const getPurchasePriceItemsById = async (id) => (await axiosInstance.get(`${API_URL}/purchase-price-items/${id}`)).data;
export const createPurchasePriceItems = async (payload) => (await axiosInstance.post(`${API_URL}/purchase-price-items`, payload)).data;
export const updatePurchasePriceItems = async (id, payload) => (await axiosInstance.put(`${API_URL}/purchase-price-items/${id}`, payload)).data;
export const deletePurchasePriceItems = async (id) => (await axiosInstance.delete(`${API_URL}/purchase-price-items/${id}`)).data;
